export enum StatusLote {
  RASCUNHO = 'RASCUNHO',
  RASCUNHO_COM_ARQUIVO = 'RASCUNHO_COM_ARQUIVO',
  RECEBIDO = 'RECEBIDO',
  VALIDANDO = 'VALIDANDO',
  VALIDO = 'VALIDO',
  AGUARDANDO_ENVIO = 'AGUARDANDO_ENVIO',
  AGENDADO = 'AGENDADO',
  CONFIRMADO_AGUARDANDO_JANELA = 'CONFIRMADO_AGUARDANDO_JANELA',
  ENVIANDO = 'ENVIANDO',
  ERRO_ESTRUTURA = 'ERRO_ESTRUTURA',
  PROCESSANDO = 'PROCESSANDO',
  PARCIALMENTE_ENVIADO = 'PARCIALMENTE_ENVIADO',
  FINALIZADO = 'FINALIZADO',
  CANCELADO = 'CANCELADO',
  ERRO = 'ERRO',
}

export enum SendMethod {
  DIGITAL = 'DIGITAL',
  EMAIL_APENAS = 'EMAIL_APENAS',
  WHATSAPP_APENAS = 'WHATSAPP_APENAS',
  SEDEX = 'SEDEX',
  DIGITAL_SEDEX = 'DIGITAL_SEDEX',
}

export enum ClassificacaoItem {
  PENDENTE = 'PENDENTE',
  VALIDA_DIGITAL = 'VALIDA_DIGITAL',
  VALIDA_CORREIO = 'VALIDA_CORREIO',
  INVALIDA = 'INVALIDA',
}

export enum TipoLote {
  LOTE = 'LOTE',
  INDIVIDUAL = 'INDIVIDUAL',
}

export enum MensagemCanal {
  EMAIL = 'EMAIL',
  WHATSAPP = 'WHATSAPP',
  SMS = 'SMS',
}

export interface PaginationInput {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface PaginationMeta {
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}
